import { render, staticRenderFns } from "./shareBusinessCard.vue?vue&type=template&id=2c7a74a9&scoped=true"
import script from "./shareBusinessCard.vue?vue&type=script&lang=js"
export * from "./shareBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./shareBusinessCard.vue?vue&type=style&index=0&id=2c7a74a9&prod&scoped=true&lang=css"
import style1 from "./shareBusinessCard.vue?vue&type=style&index=1&id=2c7a74a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a74a9",
  null
  
)

export default component.exports